module.exports = __webpack_public_path__ + "img/04_stylii_M447.627e6587.png";